import { render, staticRenderFns } from "./PlatformAdvertStair.vue?vue&type=template&id=5b129406&"
import script from "./PlatformAdvertStair.vue?vue&type=script&lang=js&"
export * from "./PlatformAdvertStair.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdvertStair.vue?vue&type=style&index=0&id=5b129406&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports